"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckboxFilter = void 0;
const react_1 = __importStar(require("react"));
const sds_1 = require("@squiz/sds");
const dxp_console_support_1 = require("@squiz/dxp-console-support");
const types_1 = require("../FilterList/types");
const CheckboxFilter = (props) => {
    const { emptyText, filterOptions, headingLevel, icon, id, listHeight, name, setFilterOptions, mode } = props;
    const filterRef = (0, react_1.useRef)(null);
    // Cache value to reset filters when cleared
    const [cacheKey, setCacheKey] = (0, react_1.useState)('');
    const [searchValue, setSearchValue] = (0, react_1.useState)('');
    const [collapse, setCollapse] = (0, react_1.useState)(true);
    const selectedCount = (0, react_1.useMemo)(() => {
        const selectedOptions = filterOptions.filter((option) => option.checked);
        return selectedOptions.length;
    }, [filterOptions]);
    const matchingOptions = (0, react_1.useMemo)(() => {
        const optionsWithKeywords = filterOptions.map((option) => {
            // Only filter by _keywords if option is unchecked
            if (option.checked) {
                return option;
            }
            return { ...option, _keywords: option.label };
        });
        return (0, dxp_console_support_1.filterByKeyword)(optionsWithKeywords, searchValue).map((item) => {
            const { _keywords, ...option } = item;
            return option;
        });
    }, [filterOptions, searchValue]);
    const displayCollapseButton = mode === types_1.FilterMode.Collapse && matchingOptions.length > 5;
    const checkboxListCallback = (callbackOptions) => {
        const optionMap = new Map();
        for (const option of callbackOptions) {
            optionMap.set(option.key, option);
        }
        const updatedOptions = structuredClone(filterOptions).map((item) => {
            if (optionMap.has(item.key)) {
                const updatedItem = optionMap.get(item.key);
                return { ...item, checked: updatedItem.checked };
            }
            return item;
        });
        setFilterOptions(updatedOptions);
    };
    const clearFilter = () => {
        const uncheckedOptions = structuredClone(filterOptions).map((item) => {
            return { ...item, checked: false };
        });
        setFilterOptions(uncheckedOptions);
        setCacheKey(new Date().toISOString());
    };
    // Re-render CheckboxList any time the search value changes,
    // so that the 'checked' states do not get out of sync.
    (0, react_1.useEffect)(() => {
        setCacheKey(new Date().toISOString());
    }, [searchValue]);
    const getCheckboxList = () => {
        if (!matchingOptions.length) {
            return (react_1.default.createElement(sds_1.SdsText, { classes: "checkbox-filter__empty", fontSize: sds_1.SdsTextSize.Medium, fontWeight: sds_1.SdsTextWeight.Semibold, text: emptyText ?? `No matching items.` }));
        }
        let optionsToDisplay = matchingOptions;
        if (displayCollapseButton) {
            optionsToDisplay = collapse ? matchingOptions.slice(0, 5) : matchingOptions;
        }
        return (react_1.default.createElement(sds_1.CheckboxList, { "aria-label": name, checkboxListCallback: checkboxListCallback, fieldLabel: name, hideLabel: true, key: cacheKey, id: id, name: name, options: optionsToDisplay, ref: filterRef, role: "group" }));
    };
    const listStyles = listHeight ? { height: `${listHeight}px` } : {};
    return (react_1.default.createElement("div", { className: "checkbox-filter" },
        react_1.default.createElement("div", { className: "checkbox-filter__header" },
            react_1.default.createElement(sds_1.SdsHeading, { classes: "checkbox-filter__heading", customTag: `h${headingLevel}`, level: 3, text: name }),
            selectedCount > 0 && (react_1.default.createElement(sds_1.Link, { classes: "checkbox-filter__clear", customClick: clearFilter, hideIcon: true, text: "Clear", type: sds_1.LINK_TYPE_BUTTON }))),
        mode === types_1.FilterMode.Search && (react_1.default.createElement("div", { className: "checkbox-filter__search" },
            react_1.default.createElement(sds_1.SearchFilter, { customIcon: icon, filterValue: searchValue, label: `Filter ${name.toLowerCase()}`, placeholder: `Filter ${name.toLowerCase()}`, setFilterValue: setSearchValue }))),
        react_1.default.createElement(sds_1.Divider, null),
        react_1.default.createElement("div", { className: "checkbox-filter__options", style: listStyles }, getCheckboxList()),
        displayCollapseButton && (react_1.default.createElement("div", { className: "checkbox-filter__collapse", onClick: () => setCollapse(!collapse) }, collapse ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("span", { className: "show-more-icon" }, sds_1.ICON_UNFOLD_MORE),
            react_1.default.createElement("p", null, "Show more"))) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("span", { className: "show-less-icon" }, sds_1.ICON_FOLD_LESS),
            react_1.default.createElement("p", null, "Show less")))))));
};
exports.CheckboxFilter = CheckboxFilter;
